import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { AuthGuard, protectedRoute } from "./helpers";

// Auth
const SignIn = lazy(() => import("../pages/sign-in/sign-in"));

// Core Pages
const DashboardPage = lazy(() => import("../pages/dashboard/dashboard"));
const MapPage = lazy(() => import("../einstein/components/map/MapPage"));
// const SearchResults = lazy(() => import("../pages/search/SearchResults"));
const Methods = lazy(() => import("../pages/methods/methods"));
const CuriosityHome = lazy(() => import("../pages/curiosity/CuriosityHome"));

// File Viewer (import concrete module, not barrel, to avoid pulling extras)
const FileViewer = lazy(
	() => import("../einstein/components/fileViewer/FileViewer"),
);

export const coreRoutes: RouteObject[] = [
	{
		path: ROUTES.LOGIN,
		element: (
			<AuthGuard>
				<SignIn />
			</AuthGuard>
		),
	},
	{
		path: ROUTES.HOME,
		element: protectedRoute(<DashboardPage />),
	},
	{
		path: ROUTES.MAP,
		element: protectedRoute(<MapPage />),
	},
	// {
	// 	path: ROUTES.SEARCH,
	// 	element: protectedRoute(<SearchResults />),
	// },
	{
		path: ROUTES.METHODOLOGIES,
		element: protectedRoute(<Methods />),
	},
	// {
	// 	path: ROUTES.CURIOSITY,
	// 	element: protectedRoute(<CuriosityHome />),
	// },
	// {
	// 	path: ROUTES.CURIOSITY_CONVERSATION,
	// 	element: protectedRoute(<CuriosityHome />),
	// },
	{
		path: ROUTES.FILE_VIEWER,
		element: protectedRoute(<FileViewer />),
	},
];
